import React from "react";

export default function Header() {
    return (
        <header className="header--main">
            <div>Pilot Andy 🧑‍✈️</div>
        </header>
    );
}